export default __webpack_public_path__ + "static/media/269.9f8e0498.gif";